"use strict";
// DO NOT EDIT. Generated by gitlab.com/accumulatenetwork/accumulate/tools/cmd/gen-types.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var Type;
(function (Type) {
    /** NodeInfoRequest . */
    Type[Type["NodeInfoRequest"] = 1] = "NodeInfoRequest";
    /** FindServiceRequest . */
    Type[Type["FindServiceRequest"] = 2] = "FindServiceRequest";
    /** ConsensusStatusRequest . */
    Type[Type["ConsensusStatusRequest"] = 3] = "ConsensusStatusRequest";
    /** NetworkStatusRequest . */
    Type[Type["NetworkStatusRequest"] = 4] = "NetworkStatusRequest";
    /** MetricsRequest . */
    Type[Type["MetricsRequest"] = 5] = "MetricsRequest";
    /** QueryRequest . */
    Type[Type["QueryRequest"] = 6] = "QueryRequest";
    /** SubmitRequest . */
    Type[Type["SubmitRequest"] = 7] = "SubmitRequest";
    /** ValidateRequest . */
    Type[Type["ValidateRequest"] = 8] = "ValidateRequest";
    /** SubscribeRequest . */
    Type[Type["SubscribeRequest"] = 9] = "SubscribeRequest";
    /** FaucetRequest . */
    Type[Type["FaucetRequest"] = 10] = "FaucetRequest";
    /** ErrorResponse . */
    Type[Type["ErrorResponse"] = 32] = "ErrorResponse";
    /** NodeInfoResponse . */
    Type[Type["NodeInfoResponse"] = 33] = "NodeInfoResponse";
    /** FindServiceResponse . */
    Type[Type["FindServiceResponse"] = 34] = "FindServiceResponse";
    /** ConsensusStatusResponse . */
    Type[Type["ConsensusStatusResponse"] = 35] = "ConsensusStatusResponse";
    /** NetworkStatusResponse . */
    Type[Type["NetworkStatusResponse"] = 36] = "NetworkStatusResponse";
    /** MetricsResponse . */
    Type[Type["MetricsResponse"] = 37] = "MetricsResponse";
    /** RecordResponse . */
    Type[Type["RecordResponse"] = 38] = "RecordResponse";
    /** SubmitResponse . */
    Type[Type["SubmitResponse"] = 39] = "SubmitResponse";
    /** ValidateResponse . */
    Type[Type["ValidateResponse"] = 40] = "ValidateResponse";
    /** SubscribeResponse . */
    Type[Type["SubscribeResponse"] = 41] = "SubscribeResponse";
    /** FaucetResponse . */
    Type[Type["FaucetResponse"] = 42] = "FaucetResponse";
    /** Event . */
    Type[Type["Event"] = 64] = "Event";
    /** PrivateSequenceRequest . */
    Type[Type["PrivateSequenceRequest"] = 128] = "PrivateSequenceRequest";
    /** PrivateSequenceResponse . */
    Type[Type["PrivateSequenceResponse"] = 129] = "PrivateSequenceResponse";
    /** Addressed . */
    Type[Type["Addressed"] = 255] = "Addressed";
})(Type = exports.Type || (exports.Type = {}));
/** @ignore */
(function (Type) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    Type.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "nodeinforequest":
                return Type.NodeInfoRequest;
            case "findservicerequest":
                return Type.FindServiceRequest;
            case "consensusstatusrequest":
                return Type.ConsensusStatusRequest;
            case "networkstatusrequest":
                return Type.NetworkStatusRequest;
            case "metricsrequest":
                return Type.MetricsRequest;
            case "queryrequest":
                return Type.QueryRequest;
            case "submitrequest":
                return Type.SubmitRequest;
            case "validaterequest":
                return Type.ValidateRequest;
            case "subscriberequest":
                return Type.SubscribeRequest;
            case "faucetrequest":
                return Type.FaucetRequest;
            case "errorresponse":
                return Type.ErrorResponse;
            case "nodeinforesponse":
                return Type.NodeInfoResponse;
            case "findserviceresponse":
                return Type.FindServiceResponse;
            case "consensusstatusresponse":
                return Type.ConsensusStatusResponse;
            case "networkstatusresponse":
                return Type.NetworkStatusResponse;
            case "metricsresponse":
                return Type.MetricsResponse;
            case "recordresponse":
                return Type.RecordResponse;
            case "submitresponse":
                return Type.SubmitResponse;
            case "validateresponse":
                return Type.ValidateResponse;
            case "subscriberesponse":
                return Type.SubscribeResponse;
            case "faucetresponse":
                return Type.FaucetResponse;
            case "event":
                return Type.Event;
            case "privatesequencerequest":
                return Type.PrivateSequenceRequest;
            case "privatesequenceresponse":
                return Type.PrivateSequenceResponse;
            case "addressed":
                return Type.Addressed;
            default:
                throw new Error(`Unknown Type '${name}'`);
        }
    }
    Type.byName = byName;
    function getName(v) {
        switch (v) {
            case Type.NodeInfoRequest:
                return "nodeInfoRequest";
            case Type.FindServiceRequest:
                return "findServiceRequest";
            case Type.ConsensusStatusRequest:
                return "consensusStatusRequest";
            case Type.NetworkStatusRequest:
                return "networkStatusRequest";
            case Type.MetricsRequest:
                return "metricsRequest";
            case Type.QueryRequest:
                return "queryRequest";
            case Type.SubmitRequest:
                return "submitRequest";
            case Type.ValidateRequest:
                return "validateRequest";
            case Type.SubscribeRequest:
                return "subscribeRequest";
            case Type.FaucetRequest:
                return "faucetRequest";
            case Type.ErrorResponse:
                return "errorResponse";
            case Type.NodeInfoResponse:
                return "nodeInfoResponse";
            case Type.FindServiceResponse:
                return "findServiceResponse";
            case Type.ConsensusStatusResponse:
                return "consensusStatusResponse";
            case Type.NetworkStatusResponse:
                return "networkStatusResponse";
            case Type.MetricsResponse:
                return "metricsResponse";
            case Type.RecordResponse:
                return "recordResponse";
            case Type.SubmitResponse:
                return "submitResponse";
            case Type.ValidateResponse:
                return "validateResponse";
            case Type.SubscribeResponse:
                return "subscribeResponse";
            case Type.FaucetResponse:
                return "faucetResponse";
            case Type.Event:
                return "event";
            case Type.PrivateSequenceRequest:
                return "privateSequenceRequest";
            case Type.PrivateSequenceResponse:
                return "privateSequenceResponse";
            case Type.Addressed:
                return "addressed";
            default:
                throw new Error(`Unknown Type ${v}`);
        }
    }
    Type.getName = getName;
})(Type = exports.Type || (exports.Type = {}));
//# sourceMappingURL=msg_enums_gen.js.map